
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Holidaylist.css";
import HolidayListView from "../../../components/mobile/HolidayListView";

import MobileLayout from "../../../layouts/MobileLayout";

import { useAuthStore } from "../../../store/authStore";
import { api } from "../../../utils/api";


const Holidaylist = () => {

  const { user, isAuthenticated } = useAuthStore();
const companyId = user?.company_id;

  

  

  const [holidayData, setHolidayData] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();





useEffect(() => {
  const fetchHolidays = async () => {
    try {
      setLoading(true);

      const response = await api.get(`/holiday/list/${companyId}`);

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.message || "Failed to load holidays"
        );
      }

      setHolidayData(Array.isArray(result) ? result : []);
    } catch (error) {
      console.error(error);
      setHolidayData([]);
    } finally {
      setLoading(false);
    }
  };

  if (companyId && isAuthenticated) {
    fetchHolidays();
  }
}, [companyId, isAuthenticated]);

  return (
    <MobileLayout>
      <HolidayListView
        holidays={holidayData}
        loading={loading}
        onBack={() => navigate(-1)}
      />
    </MobileLayout>
  );
};

export default Holidaylist;
